import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { runErrorMessage } from '@/lib/community-curation/runErrorMessage';
import type { CurationRun } from '@/lib/community-curation/types';

// Shared by the runs table and the run dialog so a held run reads the same in
// both places.
export function RunStatusBadge({ status }: { status: CurationRun['status'] }) {
  const { t } = useTranslation();
  if (status === 'held') {
    return (
      <Badge variant="outline" className="border-amber-500/60 text-amber-500">
        {t('admin.communityCuration.statuses.held')}
      </Badge>
    );
  }
  return (
    <Badge variant={status === 'failed' ? 'destructive' : 'outline'}>
      {t(`admin.communityCuration.statuses.${status}`)}
    </Badge>
  );
}

export function RunErrorText({
  run, className,
}: {
  run: Pick<CurationRun, 'error' | 'budget_units' | 'estimated_units' | 'status'>;
  className?: string;
}) {
  const { t, i18n } = useTranslation();
  const message = runErrorMessage(run);
  if (!message) return null;
  const text = 'key' in message
    ? t(message.key, Object.fromEntries(Object.entries(message.values).map(([name, value]) => [
      name, value == null ? '—' : value.toLocaleString(i18n.language),
    ])))
    : message.text;
  const tone = run.status === 'held' ? 'text-amber-500' : 'text-destructive';
  return <p className={`text-xs ${tone} ${className ?? ''}`} title={text}>{text}</p>;
}
